module.exports = __webpack_public_path__ + "img/album13_04.31a73855.jpg";